import { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from '@/contexts/LanguageContext';
import Header from '@/components/Header';
import LeftPane from '@/components/LeftPane';
import NavigationDots from '@/components/NavigationDots';
import SloganSection from '@/components/sections/SloganSection';
import QuemSomosSection from '@/components/sections/QuemSomosSection';
import PropositoSection from '@/components/sections/PropositoSection';
import ProdutosSection from '@/components/sections/ProdutosSection';
import ContatoSection from '@/components/sections/ContatoSection';
import Footer from '@/components/Footer';
import PrivacyPage from '@/components/PrivacyPage';
import ContactPage from '@/components/ContactPage';
import CookieBanner from '@/components/CookieBanner';

const SECTION_IDS = ['slogan', 'quem-somos', 'proposito', 'produtos', 'contato'];

function HomePage() {
  const [activeSection, setActiveSection] = useState('slogan');
  const location = useLocation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.35, rootMargin: '-10% 0px -10% 0px' }
    );

    SECTION_IDS.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  // Handle scroll from navigation state (coming from subpages)
  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const el = document.getElementById(location.state.scrollTo);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 150);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <div className="app-container bg-[#F9F8F6] min-h-screen">
      <Header activeSection={activeSection} />
      <LeftPane />
      <NavigationDots activeSection={activeSection} />

      <main className="relative w-full md:w-1/2 md:ml-[50%]">
        <SloganSection />
        <QuemSomosSection />
        <PropositoSection />
        <ProdutosSection />
        <ContatoSection />
        <Footer />
      </main>
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <CookieBanner />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacidade" element={<PrivacyPage />} />
          <Route path="/contato" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
